// extracted by mini-css-extract-plugin
export default {"Button":"ExpandMenuButton_Button__55RhE"};